import { useNavigate } from "react-router";
import { useShepherdGlobalState } from "../hooks/useShepherdGlobalState";
import { useEffect } from "react";
import { Loading } from "../recorderComponents/loading";
import { Drawer } from "@mui/material";

export const Tutoral = () => {
  const setShouldOpenTour = useShepherdGlobalState(
    (state) => state.setShouldOpenTour
  );
  const nav = useNavigate();

  useEffect(() => {
    setShouldOpenTour(true);
    nav("/auth/dashboard");
  });

  return (
    <Drawer
      anchor="bottom"
      open={true}
      PaperProps={{ sx: { backgroundColor: "#FFF8F0" } }}
      transitionDuration={{ exit: 500, enter: 500 }}
    >
      <Loading showLoading />
    </Drawer>
  );
};
